import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { L10nLocale, L10N_LOCALE } from 'angular-l10n';
import { AssetAttribute } from '../../hickory-api';

@Component({
  selector: 'app-associations-select-asset-attributes',
  templateUrl: './select-asset-attributes.component.html',
  styleUrls: ['./select-asset-attributes.component.scss'],
  standalone: false
})
export class SelectAssetAttributesComponent {
  @Input() attributes: AssetAttribute[];
  @Input() selectedAssetAttributes: AssetAttribute[];
  @Output() selected: EventEmitter<AssetAttribute> = new EventEmitter();

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) { }

  isSelected(attribute: AssetAttribute) {
    return this.selectedAssetAttributes.some(a => a.id === attribute.id);
  }

  onSelect(attribute: AssetAttribute) {
    this.selected.emit(attribute);
  }
}
